import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Technician,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}technician`;

const getTechniciansBySellerIdQuery = async ({
  sellerId,
}: {
  sellerId: string;
}): Promise<BackResponse<Technician[]> | BackResponseFailure> => {
  try {
    return await apiCall<BackResponse<Technician[]>>(
      buildUrl(ENDPOINT, {
        sellerId,
      }),
      { method: SUPPORTED_METHODS.GET },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getTechniciansBySellerIdQuery;
